import { useAuth } from "context/userContext";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReconnectingWebSocket from "reconnecting-websocket";
import { fetchNotificationData, handleNotifications } from "store/slice/common";


const useWebSocket = (userId, companyId) => {
//   const [messages, setMessages] = useState([]);
  const wsRef = useRef(null);
  const {
    notifications,
    notificationLoading,
    notificationCount
  } = useSelector(state=> state.common)
  const {logout} = useAuth();

  const dispatch = useDispatch();
  const navigate = useNavigate()


  useEffect(()=>{
    console.log("&&&&&&&&&&&&&&&&&&&&")
    
    dispatch(fetchNotificationData({status:false}));
    // .then(response=>{
    //     handleNotifications(response.data?.results)

    // })
  },[])
  useEffect(()=>{
console.log(notifications, "JJJ")
  },[notifications])
  useEffect(() => {
    if (!userId) return; // Do not connect without user ID
    const company = localStorage.getItem('company') || 1
    // WebSocket URL with dynamic user ID
    const wsUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/?company_user=${userId}&company=${company}`;

    // Create a WebSocket connection with auto-reconnect
    wsRef.current = new ReconnectingWebSocket(wsUrl, [], {
      maxReconnectionDelay: 10000,
      minReconnectionDelay: 1000,
      reconnectionDelayGrowFactor: 1.3,
      connectionTimeout: 4000,
      maxRetries: Infinity, // Keep retrying indefinitely
    });

    wsRef.current.onopen = () => {
      console.log("WebSocket Connected");
    };

    wsRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
    //   setMessages((prev) => [...prev, data]);
     
      console.log("Received Message:", data);
      if(data?.action_type == "system_action"){
        if(data?.data?.type == "logout"){
          logout()
          console.log("LOOGGGGGGOUTTTTT");

          navigate("/login")
          console.log("Received logout:");
        }
        return;
      }
      if(data?.action_type == "logout"){
        logout()
        console.log("LOOGGGGGGOUTTTTT");

        navigate("/login")
        console.log("Received logout:");

      }else{
        dispatch(handleNotifications(data))
        
      }
    };

    wsRef.current.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    wsRef.current.onclose = () => {
      console.warn("WebSocket Disconnected, Attempting Reconnect...");
    };

    return () => {
      wsRef.current?.close();
    };
  }, [userId, companyId]);

  const sendMessage = (message) => {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(message));
    } else {
      console.warn("WebSocket is not connected");
    }
  };

  return { notifications, sendMessage, notificationLoading, notificationCount };
};

export default useWebSocket;
